<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" id="addEarningModal" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Add Position</h3>
        </template>

        <slot>
            <form-errors :errors="formErrors"/>

            <div v-if="dataLoaded">
                <template v-for="i in 5">
                    <form-input v-if="i == client.location_org_level" label="Location" type="select" :options="locationOptions" v-model="formData.work_location" :errors="errors.work_location"/>
                    <form-input v-else-if="orgOptionsByLevel[i] && orgOptionsByLevel[i].length" :label="client[`org_level_${i}_label`]" type="select" :options="orgOptionsByLevel[i]" v-model="formData[`org_level_${i}_value`]" :errors="errors[`org_level_${i}_value`]"/>
                </template>
                <form-input v-if="formData.work_location" label="Pay Group" type="select" :options="paygroupOptions" v-model="formData.paygroup" :errors="errors.paygroup"/>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', ],
    mixins: [FormMixin, ModalMixin],
    components: {},
    data() {
        return {
            formData: this.makeFormData(),
            orgs: [],
            orgsLoaded: false,
            locationsLoaded: false,
            paygroupsLoaded: false
        }
    },
    mounted() {
        this.getOrgs()
        this.getLocations()
        this.getPaygroups()
    },
    watch: {
        dataLoaded(val) {
            if (val) {
                this.$store.dispatch('STOP_LOADING')
            }
        }
    },
    computed: {
        dataLoaded() {
            return this.orgsLoaded && this.locationsLoaded && this.paygroupsLoaded
        },
        orgOptionsByLevel() {
            let result = {}
            for (let i = 1; i <= 5; i++) {
                result[i] = []
                this.orgs.filter(o => o.org_level == i).forEach(o => {
                    result[i].push({text: o.org_level_description, value: o.org_level_description})
                })
            }
            return result
        },
        locationOptions() {
            let result = []
            this.locations.forEach(l => {
                result.push({text: l.name, value: l.id})
            })
            return result
        },
        paygroupOptions() {
            let result = []
            let paygroups = this.paygroups
            if (this.formData.work_location) {
                let location = this.locations.find(l => l.id == this.formData.work_location)
                paygroups = this.paygroups.filter(p => p.company_id == location.company_id)
            }
            paygroups.forEach(l => {
                result.push({text: l.name, value: l.id})
            })
            return result
        }
    },
    methods: {
        getOrgs() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/company-orgs`).then(resp => {
                this.orgs = resp
                this.orgsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        getLocations() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/locations`).then(resp => {
                this.locations = resp
                this.locationsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        getPaygroups() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/paygroups`).then(resp => {
                this.paygroups = resp
                this.paygroupsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                org_level_1_value: null,
                org_level_2_value: null,
                org_level_3_value: null,
                org_level_4_value: null,
                org_level_5_value: null,
                work_location: null,
                paygroup: null,
            }

            return data
        },
        resetErrors() {
            this.errors =  {}
            this.formErrors = []
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/settings/positions`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
                this.close()

            }).catch((errors) => {
                console.log(errors)
                this.$store.dispatch('STOP_LOADING')

                this.formErrors = (errors.__all__ || [])
                this.$bus.showError('Please check the form for any missing fields.')
            })
        },
    }
}
</script>
